import { useTranslation } from "react-i18next";

import { SUPPORTED_LANGUAGES, type SupportedLanguage } from "@/lib/i18n";

import { Select, SelectItem, SelectValue } from "@/components/base/Select";

export const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  return (
    <Select
      name="language"
      value={i18n.language}
      onValueChange={(value) => void i18n.changeLanguage(value)}
      trigger={<SelectValue />}
      className="w-auto shrink-0"
      triggerProps={{ className: "h-10 w-auto min-w-28" }}
    >
      {(
        Object.entries(SUPPORTED_LANGUAGES) as [SupportedLanguage, string][]
      ).map(([code, label]) => (
        <SelectItem key={code} value={code} className="cursor-pointer">
          {label}
        </SelectItem>
      ))}
    </Select>
  );
};
